commonModule.factory('ssoAuthenticationService', ['$http', 'AppSettings', 'commonRESTCallService', 'identityMgmntService', '$q','userAuthenticateService', 'commonTLCService',
function ($http, AppSettings, commonRESTCallService, identityMgmntService, $q, userAuthenticateService, commonTLCService) {
    var ssoAPI = {};

    //
    //assists in doing SSO authentication
    // from a token-based SSO strategy
    //

    //retrieve the SSO data from the token
    ssoAPI.retrieveSSOUserDealerInfo = function(tokenGuid, spanDealerId){
        var deferred = $q.defer();

        commonTLCService.encryptNumeric(spanDealerId)
            .then(function(encryptedSpanDealerId) {
                var url = AppSettings.startSPANPlusSvcURL + "sso-authentication/partner-token/" +
                    tokenGuid + "/" + encryptedSpanDealerId;
                return commonRESTCallService.getFromServer(url);
            })
            .then(function(ssoInfo){
                deferred.resolve(ssoInfo.data);
            },
            function(err){
                deferred.reject(err);
            });

        return deferred.promise;
    }
    //retrieve the SSO data from the token
    ssoAPI.retrieveSSOUserInfo = function(tokenGuid){
        var url = AppSettings.startSPANPlusSvcURL + "sso-authentication/partner-token/" +
            tokenGuid;

        return commonRESTCallService.getFromServer(url);
    }
    //set the user token for the session
    ssoAPI.setupSSOUser = function(imUser){
        var defer = $q.defer();

        //sets the logged in user as the "SSO" user from Menu
        identityMgmntService.getUserSSOToken(imUser.Id)
            .then(function(usertoken){
                //set the user's auth token to user session (for future API calls)
                userAuthenticateService.setUserToken(usertoken);

                defer.resolve(true);
            },
            function(err){
                defer.reject(err);
            });

        return defer.promise;
    }

    return ssoAPI;
}
]);
